import { Typography } from 'antd';
import { DeclarationTypes } from 'store/declarations/enums/common/declaration-types';

const linksMap: Partial<
    Record<
        DeclarationTypes,
        {
            href: string;
            text: string;
        }
    >
> = {
    [DeclarationTypes.AIS]: {
        href: 'https://www.ros.ie/',
        text: 'Go to ROS.ie',
    },
    [DeclarationTypes.AES]: {
        href: 'https://www.ros.ie/',
        text: 'Go to ROS.ie',
    },
};

type Props = {
    declarationType: DeclarationTypes | undefined;
};

const LinkToCustomsOnlineServices = ({ declarationType }: Props) => {
    if (!declarationType) return null;

    const href = linksMap[declarationType]?.href;
    const text = linksMap[declarationType]?.text;

    if (!href || !text) return null;

    return (
        <Typography.Link
            href={href}
            target="_blank"
            style={{
                borderRadius: 6,
                padding: '4px 16px',
                border: '1px solid var(--brand-6)',
                color: 'var(--brand-6)',
            }}
        >
            {text}
        </Typography.Link>
    );
};

export default LinkToCustomsOnlineServices;
